import { render } from "./App.vue?vue&type=template&id=5d9f61a0&scoped=true&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=5d9f61a0&scoped=true&lang=css"

import exportComponent from "/builds/unicoop-firenze/app-prezzi-concorrenza/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d9f61a0"]])

export default __exports__